interface InfoWithEmailAddress {
    emailAddress: string;
}

export default function findEmailAddress(
    emailAddress: string,
    infos: InfoWithEmailAddress[]
): boolean {
    return infos.some(info => info.emailAddress === emailAddress);
}
